var lib_core  = require("lib-core");
var Editor2DController = require("../editor2D/editor2DController.js");
var SelectionController = require("../selection/selectionController.js");

var MovingStateMachine    = require("./movingStateMachine.js");
var KeyMovingStateMachine = require("./keyMovingStateMachine.js");
var MovingModel           = require("./movingModel.js");

var MovingController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(MovingController, lib_core.Controller);
MovingController.inject = {
    editor2DController : Editor2DController,
    selectionController : SelectionController
};

module.exports = MovingController;

MovingController.prototype.createStateMachine = function () {
    var editorModel = this.editor2DController.getModel();

    // selection is the default collection for the moving controller
    var moveCollection = this.selectionController.getModel().selection;

    // keyMoving SM has to be appended seperately
    this.keyMovingStateMachine = new KeyMovingStateMachine(this.root, this.getModel(), editorModel, moveCollection);

    return new MovingStateMachine(this.root, this.getModel(), editorModel, moveCollection);
};

MovingController.prototype.createModel = function () {
    var editorModel = this.editor2DController.getModel();
    var movingModel = new MovingModel(editorModel);

    // TODO: get rid of this nasty stuff
    editorModel.movingModel = editorModel.value("moving", false);
    editorModel.movingModel(movingModel);
    
    return movingModel;
};

MovingController.prototype.afterLoad = function () {
    this.autoAppendArgs = ["mouse_down", null, "mouse_down", null, "idle"];
    lib_core.Controller.prototype.afterLoad.call(this);

    this.parent().getStatemachine().append("keyMoving", this.keyMovingStateMachine, "idle", null, "idle", null);
};
